import React from "react";
import classes from "./ViewerProps.module.css";

interface ViewerPropsRowParams {
    paramName: string;
    value: string | number | boolean;
    isSearched: boolean;
}
function ViewerPropsRow({
    paramName,
    value,
    isSearched = false,
}: ViewerPropsRowParams) {
    return (
        <div
            className={[
                classes.ParamRowWrap,
                isSearched ? classes.searched : "",
            ].join(" ")}
        >
            <div title={paramName} className={[classes.valueWrap].join(" ")}>
                {paramName}
            </div>
            <div
                title={value?.toString()}
                className={[classes.valueWrap].join(" ")}
            >
                {value}
            </div>
        </div>
    );
}

export default ViewerPropsRow;
